<template>
<div class="">
    <div class="select is-fullwidth dropdown"
        v-on-clickaway="away"
        :class="{'is-active': isActive}">
      <button class="input tag-input dropdown-trigger" :class="{'is-danger is-outlined': error}"
              @click="toggleDropdown"
              aria-controls="dropdown-menu">
              <span class="placeholder" v-if="!value || value.length === 0">
                {{ placeholder }}
              </span>
        <div class="field is-grouped">
          <div class="taggy" v-for="(tag, index) in value"
            :key="index">
            <div class="tags has-addons">
              <span class="tag">{{ tag }}</span>
              <a class="tag is-delete" href="#" v-on:click.stop="remove(index)"></a>
            </div>
          </div>
        </div>
      </button>
      <div class="dropdown-menu is-expanded dropdown-layout dropdown-content margin-top margin-bottom" role="menu">
        <div class="scroll-section">
          <a class="dropdown-item"
            v-for="(option, index) in options"
            @click="selectedOption(index)"
            :key="index">
            {{ option }}
          </a>
        </div>
        <div v-if="footer" class="scroll-footer">
          <hr>
          <p>{{footerText}}</p>
        </div>
      </div>
    </div>
    <div>
      <p class="help is-danger is-danger-validation error-validation" v-if="error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  props: {
    options: {
      type: Array,
      default: () => ['Option A', 'Option B']
    },
    value: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: null
    },
    footer: {
      type: Boolean,
      default: false
    },
    footerText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    remove (index) {
      this.isActive = false
      this.value.splice(index, 1)
      this.$emit('input', this.value)
    },
    toggleDropdown () {
      this.isActive = !this.isActive
    },
    away () {
      this.isActive = false
      this.$emit('validate')
    },
    selectedOption (index) {
      const option = this.options[index]
      if (!this.value.includes(option)) {
        this.value.push(option)
      }

      this.$emit('input', this.value)
      this.$emit('validate')
    }
  }
}
</script>

<style lang="scss" scoped>
$border-color: #ddd;

.tag:not(body).is-delete {
  margin-left: 0;
}

.tag:not(.is-delete) {
  border: solid 1px $border-color;
  border-right: none;
}

.tag:not(body).is-delete {
  border: solid 1px $border-color;
  border-left: none;
}

.button {
  padding-left: 0.5rem;
}

select {
  position: relative;
  top: -36px;
  visibility: hidden;
}

.taggy {
  margin-right: 0.5rem;
}

.placeholder {
  color: #a9a9a9;
  margin-left: 0.5rem;
}

.error-validation {
  position: absolute;
}
.dropdown-layout{
  width : 100%
}
.margin-top{
  margin-top: 10px;
}
.scroll-section{
  max-height: 200px;
  overflow-y: scroll;
}
.scroll-footer{
  margin-right: 20px;
  margin-left: 20px;
}
.margin-bottom{
  margin-bottom: 200px
}

</style>



// WEBPACK FOOTER //
// src/components/general/tag-select.vue